export default {
  path: '/steps',
  name: 'Step',
  component: () => import('../components/step/Layout'),
  redirect: { name: 'StepList' },
  meta: {
    breadcrumb: 'process.steps',
  },
  children: [

  ]
};
